import React from "react";

interface Props {
  className?: string;
  size?: number;
}

const TrendingUp: React.FC<Props> = ({ className, size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.75313 14.0816L1.79688 13.1254L7.06563 7.85664L9.91563 10.7066L13.8906 6.75039H11.6969V5.40039H16.1969V9.90039H14.8469V7.70664L9.91563 12.6191L7.06563 9.76914L2.75313 14.0816Z"
        fill="var(--iconSuccess)"
      />
    </svg>
  );
};

export default TrendingUp;
